"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const browser_1 = require("./browser");
const helpers_1 = require("./helpers");
class TrackerFilters {
    constructor(tracker) {
        this.tracker = null;
        this.filters = [];
        this.tracker = tracker;
    }
    add(filter) {
        this.filters.push(filter);
    }
    run(params) {
        try {
            for (const key in this.filters) {
                if (key) {
                    const param = params.get(this.filters[key]);
                    if (param && helpers_1.default.isFunction(param)) {
                        param.call(browser_1.default.getWindow(), this.tracker);
                    }
                }
            }
        }
        catch (err) {
            // ignore
            console.error(err);
        }
    }
}
exports.default = TrackerFilters;
